import styled from 'styled-components';

export const ExpenseFormContainer = styled.div`
    width: 25rem;
`;